import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const stateSchema = Yup.object().shape({
  name: Yup.string().required(message.CITY_REQUIRED),
  stateId: Yup.string().required(message.STATE_REQUIRED),
});
